module.exports = __webpack_public_path__ + "img/923-ef24ab.png";